"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderSublabels = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var styled_components_1 = __importDefault(require("styled-components"));
var FlexSpaceBetween = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var FlexColumn = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var SubLabelValue = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ", "\n"])), helios_styles_1.text.default, helios_styles_1.body.regular.sm);
var SubLabel = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ", "\n"])), helios_styles_1.text.default, helios_styles_1.body.regular.xs);
var renderSublabelValue = function (toRenderValue) {
    if (typeof toRenderValue === 'string')
        return toRenderValue;
    if (toRenderValue.display)
        return toRenderValue.display({ value: toRenderValue.value });
    return toRenderValue.value;
};
var renderSublabels = function (toRenderValue) {
    if (typeof toRenderValue === 'string')
        return null;
    return toRenderValue.sublabel;
};
function RenderSublabels(_a) {
    var max = _a.max, min = _a.min;
    var minSublabel = renderSublabels(min);
    var maxSublabel = renderSublabels(max);
    return ((0, jsx_runtime_1.jsxs)(FlexSpaceBetween, { children: [(0, jsx_runtime_1.jsxs)(FlexColumn, { children: [(0, jsx_runtime_1.jsx)(SubLabelValue, { children: renderSublabelValue(min) }), minSublabel && (0, jsx_runtime_1.jsx)(SubLabel, { children: minSublabel })] }), (0, jsx_runtime_1.jsxs)(FlexColumn, __assign({ style: { textAlign: 'right' } }, { children: [(0, jsx_runtime_1.jsx)(SubLabelValue, { children: renderSublabelValue(max) }), maxSublabel && (0, jsx_runtime_1.jsx)(SubLabel, { children: maxSublabel })] }))] }));
}
exports.RenderSublabels = RenderSublabels;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
